import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { Card } from 'react-bootstrap';

import UttamKalakarHeader from './UttamKalakarHeader';
import UttamKalakarFooter from './UttamKalakarFooter';

function ReviewUpload() {

    const [titlesList, setTitlesList] = useState([]);
    const [selectedTitle, setSelectedTitle] = useState('');
    const [reviewfeedback, setReviewFeedback] = useState('');
    const [loading, setLoading] = useState(false);

    // ✅ Fetch Titles
    useEffect(() => {
        axios.get('https://nrdruhs.in/api/manuscriptTitlesReviewDone')
            .then((res) => {
                setTitlesList(res.data.titles);
            })
            .catch((err) => {
                console.error('Error fetching titles:', err);
            });
    }, []);

    // ✅ Submit Function
    const handleSubmit = async () => {

        if (!selectedTitle || !reviewfeedback) {
            Swal.fire({
                icon: 'error',
                title: 'Error!',
                text: 'Please select a title and enter feedback.',
            });
            return;
        }

        // 🔥 Find selected article object
        const selectedArticle = titlesList.find(
            t => t.title === selectedTitle
        );

        if (!selectedArticle) {
            Swal.fire({
                icon: 'error',
                title: 'Error!',
                text: 'Invalid title selected.',
            });
            return;
        }

        // 🔴 Block if already submitted
        if (selectedArticle.reviewfeedback && selectedArticle.reviewfeedback.trim() !== '') {
            Swal.fire(
                "Already Submitted",
                "You have already submitted feedback for this article",
                "warning"
            );
            return;
        }

        const selectedArticleId = selectedArticle.articleid;

        setLoading(true);

        try {
            // ✅ API call
            await axios.post('https://nrdruhs.in/upload/uploadreviewarticle', {
                articleid: selectedArticleId,
                reviewfeedback: reviewfeedback,
            });

            Swal.fire({
                icon: 'success',
                title: 'Success!',
                text: 'Feedback submitted successfully.',
            });

            // Reset
            setSelectedTitle('');
            setReviewFeedback('');

        } catch (error) {
            console.error(error);

            const msg = error.response?.data?.error || 'Something went wrong';

            Swal.fire({
                icon: 'error',
                title: 'Error!',
                text: msg,
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <UttamKalakarHeader />

            <div className="container" style={{ paddingTop: 45, paddingBottom: 45 }}>
                <h3 style={{ textAlign: 'center', padding: 30, fontWeight: 'bold' }}>
                    ARTICLE FEEDBACK BY REVIEWER
                </h3>

                {/* Dropdown */}
                <Card style={{ margin: '0 auto', maxWidth: 600, background: 'linear-gradient(to right, #5433ff, #20bdff, #a5fecb)'  }}>
                    <Card.Body>
                        <select
                            className="form-select form-select-lg"
                            value={selectedTitle}
                            onChange={(e) => setSelectedTitle(e.target.value)}
                        >
                            <option value="">Select a title</option>

                            {titlesList.map((t) => {
                                const displayTitle = t.title.length > 66
                                    ? `${t.title.substring(0, 66)}...`
                                    : t.title;

                                return (
                                    <option
                                        key={t.articleid}
                                        value={t.title}
                                        disabled={t.reviewfeedback && t.reviewfeedback.trim() !== ''}
                                    >
                                        {displayTitle} {t.reviewfeedback ? "✔ Submitted" : ""}
                                    </option>
                                );
                            })}
                        </select>
                    </Card.Body>
                </Card>

                {/* Feedback */}
                <div className="mt-4">
                    <Card>
                        <Card.Body>
                            <h5 style={{ textAlign: 'center' }}>Feedback</h5>

                            <textarea
                                className="form-control"
                                value={reviewfeedback}
                                onChange={(e) => setReviewFeedback(e.target.value)}
                                rows="4"
                                placeholder="Enter your feedback here..."
                            />
                        </Card.Body>
                    </Card>
                </div>

                {/* Button */}
                <div className="text-center mt-4" style={{ marginBottom: 60 }}>
                    <button
                        className="btn btn-warning"
                        onClick={handleSubmit}
                        disabled={loading}
                        style={{ fontSize: '20px', fontWeight: 'bold', padding: '10px 25px' }}
                    >
                        {loading ? 'Submitting...' : 'SEND FEEDBACK'}
                    </button>
                </div>
            </div>

            <UttamKalakarFooter />
        </div>
    );
}

export default ReviewUpload;